import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import FilterModel from '../../models/FilterModel';

const initialState: FilterModel[] = [];

export const filterDataSlice = createSlice({
 name: 'filterData',
 initialState,
 reducers: {
  filterData: (state, action: PayloadAction<FilterModel[]>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { filterData } = filterDataSlice.actions;

export default filterDataSlice.reducer;
